import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import './style.css';

import { LeftMenuNavigator } from '../../components';

import Cooperativa from './cooperativa';
import Administracao from './administracao';
import Colaboradores from './colaboradores';
import Estatuto from './estatuto';
import RelatoriosLegais from './relatoriosLegais';
import Indicadores from './indicadores';

const routes = [
  {
    title: 'A cooperativa',
    link: '',
  },
  {
    title: 'Administração',
    link: '/administracao',
  },
  {
    title: 'Colaboradores',
    link: '/colaboradores',
  },
  {
    title: 'Estatuto',
    link: '/estatuto',
  },
  {
    title: 'Relatórios Legais',
    link: '/relatorios-legais',
  },
  {
    title: 'Indicadores',
    link: '/indicadores',
  },
];

function Institucional() {
  let { path } = useRouteMatch();
  return (
    <div id="institucionalMain">
      <LeftMenuNavigator title="Institucional" routes={routes} />
      <div id="institucionalContentContainer">
        <Switch>
          <Route exact path={path}>
            <Cooperativa />
          </Route>
          <Route path={`${path}/administracao`}>
            <Administracao />
          </Route>
          <Route path={`${path}/colaboradores`}>
            <Colaboradores />
          </Route>
          <Route path={`${path}/estatuto`}>
            <Estatuto />
          </Route>
          <Route path={`${path}/relatorios-legais`}>
            <RelatoriosLegais />
          </Route>
          <Route path={`${path}/Indicadores`}>
            <Indicadores />
          </Route>
        </Switch>
      </div>
    </div>
  )
}

export default Institucional;
